<div  class="short-cart" >
  <div class="overlay" (click)="closeWidget()" ></div>
  <div class="container-wrap-cart">
    <div  class="wrap-cart" >
      <div class="header">
        <div class="header-title">
          <span>{{'ordered-products' | translate}}</span>
          <i class="icon icon-close" (click)="closeWidget()"></i>
        </div>
        <div class="header-form">
          <form [formGroup]="formOutlets">
            <div class="form-outlet">
              <app-field-select-input
                panelClass="suppliers-outlets-panel widget"
                fieldClass="suppliers-outlets-field"
                [icon]="'icon-shop'"
                [name]="'outletId'"
                [floatLabel]="'none'"
                [group]="formOutlets"
                [options]="userSuppliersAndOutlets"
                [showParam]="'outletName'"
                [valueParam]="'outletId'"
                [disableOptionCentering]="true"
                [iconOptionClassName]="'icon-add_to_cart'"
              ></app-field-select-input>
            </div>
            <div class="form-payer" *ngIf="payers?.length">
              <app-field-select-input
                panelClass="suppliers-outlets-panel widget"
                fieldClass="suppliers-outlets-field"
                [icon]="'icon-user'"
                [name]="'payerId'"
                [floatLabel]="'none'"
                [group]="formOutlets"
                [options]="payers"
                [showParam]="'payerName'"
                [valueParam]="'payerId'"
                [disableOptionCentering]="true"
              ></app-field-select-input>
            </div>
          </form>
        </div>
      </div>

      <div class="products" *ngIf="!isCartEmpty; else emptyCart">
        <ng-container *ngFor="let product of (selectedGroup?.products
         | sort: false: false: 'productId')
         | sortByBoolean: true: ['isLogistic', 'isBonus']
         trackBy: trackByproductsInCartNew; let i = index">
          <div *ngIf="product?.isBonus && !productIsBonus(i - 1)" class="bonus-header">
            <i class="icon icon-gift"></i>
            <span>{{ 'select-bonus' | translate }}</span>
          </div>
          <app-cart-detail-item
            [product]="product"
            [priceWithVatMode]="true"
            (isEditBonusProduct)="clickEditBonus($event)"
            [isNeedToChangeSuppAndOutlets]="true"
            [isUsePromo]="isUsePromo"
            [hideLeftOvers]="true">
          </app-cart-detail-item>
        </ng-container>
      </div>
      <ng-template #emptyCart>
        <div class="empty">
          <img class="empty-cart-img" src="./assets/img/empty-cart.svg" alt="">
          <div class="first-text">{{ 'cart-preview.empty-first-text' | translate }}</div>
          <div class="second-text">{{ 'cart-preview.empty-second-text' | translate }}</div>
        </div>
      </ng-template>
      <div class="footer">
        <app-cart-widget-footer
          [mobile]="true"
          [setIsWidget]="true"
          [setPreCalculatedTotal]="preCalculatedTotal"
        >
        </app-cart-widget-footer>
        <div class="footer-action">
          <button class="btn-primary btn-apply"
                  [disabled]="!(cartService?.productsInCartNew.length > 0)"
                  (click)="goToCartItem()">
            {{'go_to_cart' | translate}}
          </button>
          <button class="btn-secondary full-width" routerLink="catalog" (click)="closeWidget()">
            {{ 'back-to-catalog' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
